<template>

</template>

<script>
export default {
  name: "GDPRRequestsPage"
}
</script>


